import mixpanel from "mixpanel-browser";
import React from "react";

import { useLocalStorage } from "../../hooks";
import { toTitleCase } from "../../utils";
import { DSToggle } from "../design-system/molecules";

function PreferenceToggle({
  toggleState,
  setToggleState,
  preferenceKey,
  dataTestId,
}) {
  const handleToggle = () => {
    const newValue = !toggleState;
    setToggleState(newValue);
    mixpanel.track("Updated Account Setting", {
      settingName: toTitleCase(preferenceKey),
      settingKey: preferenceKey,
      settingValue: newValue,
    });
  };

  return (
    <div className="flex flex-row items-center space-x-2 cursor-pointer">
      <DSToggle
        checked={toggleState}
        onChange={handleToggle}
        dataTestId={dataTestId}
        aria-label={toTitleCase(preferenceKey)}
      />
    </div>
  );
}

export function ExportSOAPKeyInfoToggle() {
  const preferenceKey = "should-export-note-key-info";
  const [shouldShowNoteKeyInfo, setShouldShowNoteKeyInfo] =
    useLocalStorage(preferenceKey);

  return (
    <PreferenceToggle
      preferenceKey={preferenceKey}
      toggleState={shouldShowNoteKeyInfo}
      setToggleState={setShouldShowNoteKeyInfo}
      dataTestId="export-key-info-toggle"
    />
  );
}

export function ExportSOAPSignalmentToggle() {
  const preferenceKey = "should-show-patient-signalment";
  const [
    shouldShowPatientSignalment,
    setShouldShowPatientSignalment,
  ] = useLocalStorage(preferenceKey);

  return (
    <PreferenceToggle
      preferenceKey={preferenceKey}
      toggleState={shouldShowPatientSignalment}
      setToggleState={setShouldShowPatientSignalment}
      dataTestId="export-signalment-toggle"
    />
  );
}

export function PageSaverToggle() {
  const preferenceKey = "page-saver";
  const [shouldEnablePageSaver, setShouldEnablePageSaver] =
    useLocalStorage(preferenceKey);

  return (
    <PreferenceToggle
      preferenceKey={preferenceKey}
      toggleState={shouldEnablePageSaver}
      setToggleState={setShouldEnablePageSaver}
      dataTestId="page-saver-toggle"
    />
  );
}
